import { lazy } from "react";

const CiroRoutes = [
  {
    path: "/reference",
    component: lazy(() => import("../../views/reference/Reference")),
  },
  //   {
  //     path: "/ciro/table",
  //     component: lazy(() => import("../../views/ciro/CiroTable")),
  //   },
];

export default CiroRoutes;
